export default __webpack_public_path__ + "static/media/IMG_0383-2.7323f936.jpg";